<table class="truck-tires-table" matSort (matSortChange)="sort($event)">
  <thead>
    <tr>
      <th mat-sort-header="{{ COL_SEAT }}">{{ 'tire.seat' | translate }}</th>
      <th mat-sort-header="{{ COL_TRUCK_SPEC }}">{{ 'tire.truckSpecification' | translate }}</th>
      <th>{{ 'tire.historicalMix' | translate }}<span class="tire-th-unit">{{ 'tire.unit.percentage' | translate }}</span></th>
      <th>{{ 'tire.targetedMix' | translate }}<span class="tire-th-unit">{{ 'tire.unit.percentage' | translate }}</span></th>
      <th>{{ 'tire.tireLife' | translate }}<span class="tire-th-unit">{{ 'tire.unit.hours' | translate }}</span></th>
      <th>{{ 'tire.comment' | translate }}</th>
      <th>{{ 'tire.action' | translate }}</th>
    </tr>
  </thead>
  <tbody>
  @if(!isLoading() && (!filteredTireSetting || filteredTireSetting.length === 0)) {
    <tr>
      <td colspan="7">
        <tkc-no-data></tkc-no-data>
      </td>
    </tr>
  }

    @for (row of filteredTireSetting; track row; let i = $index) {
      @switch (row.value.type) {
        <!-- Ligne TRUCK -->
        @case (LINE_TYPE_TRUCK) {
          <tr (click)="toggleExpand(row.value.truckSpecId)" class="expandable-row">
          <td>
            <div class="seat-cell">
              @if (row.value.hasChildren) {
                @if(row.value.expanded) {
                  <mat-icon class="expand-icon">expand_more</mat-icon>
                } @else {
                  <mat-icon class="expand-icon">chevron_right</mat-icon>
                }
              }
              {{ row.value.seat }}
            </div>
          </td>
          <td>{{ row.value.truckSpecLabel }}</td>
          <td colspan="5">
            @if (!row.value.hasChildren) {
              <div class="truck-add-tire-spec-cell">
                <button mat-flat-button (click)="openAddTireSpecificationModal(row.value.truckSpecId)">
                  {{ 'tire.addTireSpecification' | translate }}
                </button>
              </div>
            }
          </td>
        </tr>
        }
        <!-- Ligne TIRE_DETAIL -->
        @case (LINE_TYPE_TIRE_DETAIL) {
          <tr class="detail-row" [class.expanded]="row.value.expanded">
          <td colspan="2" class="detail-row-td">
            <div class="detail-row-cell-content tire-spec-cell"
                 [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">
              {{ row.value.tireSpecificationFull }}
            </div>
          </td>
          <td class="detail-row-td tkc-number detail-row-historical-mix">
            <div class="detail-row-cell-content"
                 [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">
              {{ row.value.historicalMix }}
            </div>
          </td>
          <td class="detail-row-td">
            <div class="detail-row-cell-content"
                 [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">
              <input matInput type="text"
                     class="tkc-input"
                     maxlength="3"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     (input)="tireDetailInput(row, true)"
                     (change)="targetedMixChange(row)"
                     [ngClass]="{'ng-invalid':row.controls.targetedMix?.invalid}"
                     [formControl]="row.controls.targetedMix"
              />
            </div>
          </td>
          <td class="detail-row-td">
            <div class="detail-row-cell-content"
                 [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">

                <div class="input-edited-wrapper">
                  @if (row.value.hasManualHours) {
                    <span class="input-edited-marker"></span>
                  }
                  <input matInput type="text"
                         maxlength="5"
                         class="tkc-input"
                         nxNoScroll
                         [mask]="digitMask"
                         [patterns]="digitPatterns"
                         [ngClass]="{'ng-invalid':row.controls.editingHours?.invalid}"
                         [formControl]="row.controls.editingHours"
                         (input)="onInputTireLife(row)"
                         (change)="editingHoursChange(row)"
                  />
                </div>
            </div>
          </td>
          <td class="detail-row-td">
            <div class="detail-row-cell-content"
                 [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">
              <input matInput type="text"
                     class="tkc-input"
                     nxNoScroll
                     [ngClass]="{'ng-invalid': row.controls.comment?.invalid}"
                     [formControl]="row.controls.comment"
                     (input)="tireDetailInput(row, false)"
              />
            </div>
          </td>
          <td class="detail-row-td">
            <div class="detail-row-cell-content action-cell"
                 [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">
              <button mat-icon-button matTooltip="{{'tire.tooltip.revert-btn' | translate }}" class="icon-redo"
                      (click)="removeManualValue(row)"
                      [disabled]="!(row.value.hasManualHours || ((row.controls.comment?.value || '') + '').trim().length > 0)"
                      [attr.aria-disabled]="!(row.value.hasManualHours || ((row.controls.comment?.value || '') + '').trim().length > 0)">
                <mat-icon>redo</mat-icon>
              </button>
              <button mat-icon-button matTooltip="{{'tire.tooltip.delete-btn' | translate }}" color="warn" (click)="removeTireSpecification(row.value.truckSpecId, row.value.tireSpecId)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </tr>
        }
        <!-- Ligne TOTAL -->
        @case (LINE_TYPE_TOTAL) {
          <tr class="total-row" [class.expanded]="row.value.expanded">
          <td colspan="2" class="detail-row-td">
            <div class="detail-row-cell-content add-tire-spec-cell"
                 [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">
              <button mat-flat-button (click)="openAddTireSpecificationModal(row.value.truckSpecId)">
                {{ 'tire.addTireSpecification' | translate }}
              </button>
            </div>
          </td>
          <td class="detail-row-td total-cell">
            <div class="detail-row-cell-content total-percentage-label"
                 [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">
              {{ 'tire.total' | translate }}
            </div>
          </td>
          <td class="detail-row-td">
            <div class="detail-row-cell-content total-percentage"
              [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'"
              [ngClass]="{'invalid-total-percentage': row.value.totalPercentage !== 100, 'valid-total-percentage': row.value.totalPercentage === 100 }"
            >
              {{ row.value.totalPercentage }}%
            </div>
          </td>
          <td colspan="3" class="detail-row-td">
            @if (row.value.totalPercentage !== 100) {
              <div class="detail-row-cell-content total-percentage-warning"
                   [@expandTrigger]="row.value.expanded ? 'expanded' : 'collapsed'">
                <mat-icon class="total-percentage-warning-icon">warning</mat-icon>
                {{ 'tire.totalPercentageWarning' | translate }}
              </div>
            }
          </td>
        </tr>
        }
      }
    }
  </tbody>
</table>
